import styled from 'styled-components';

export const StyledPaymentMethodWrapper = styled.div`
  padding: 24px;

  &:not(:last-child) {
    border-bottom: 1px solid #e6e9ec;
  }
`;
